import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  ConfigModule,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  UrlModule,
} from '@spartacus/core'
/* import { PromotionsModule } from '../../checkout/components/promotions/promotions.module';
import { CartSharedModule } from '../cart-shared/cart-shared.module';
import { CartCouponModule } from '../cart-coupon/cart-coupon.module'; */
import { CartDetailsComponent } from './cart-details.component'
import { CartSharedModule } from '../cart-shared/cart-shared.module'
import { SavedCartModule } from '../saved-cart/saved-cart.module'
import { DIALOG_TYPE, SpinnerModule } from '@spartacus/storefront'
import { CustomGlobalCartMsgComponent } from './custom-global-msg/custom-global-msg.component'
import { CustomProductRoutesModule } from '../../config/product-routes.module'
import { NgSelectModule } from '@ng-select/ng-select'
import { FormsModule } from '@angular/forms'
import { NonBuyablePartsComponent } from './non-buyable-parts/non-buyable-parts.component'
import { environment } from '../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@NgModule({
  imports: [
    CartSharedModule,
    CommonModule,
    // CartCouponModule,
    RouterModule,
    FormsModule,
    UrlModule,
    // PromotionsModule.,
    FeaturesConfigModule,
    I18nModule,
    SavedCartModule,
    SpinnerModule,
    CustomProductRoutesModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['savedCart'],
        },
      },
    }),
  ],
  providers: [
    /*     provideDefaultConfig( {
          cmsComponents: {
            CartComponent: {
              component: CartDetailsComponent,
            },
          },
        } as CmsConfig), */
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.NON_BUYABLE_PARTS]: {
          inlineRoot: true,
          component: NonBuyablePartsComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  declarations: [
    CartDetailsComponent,
    CustomGlobalCartMsgComponent,
    NonBuyablePartsComponent,
  ],
  exports: [CartDetailsComponent],
})
export class CartDetailsModule {}
